/**
 * @generated SignedSource<<ff168d0c48feb770d902c19b185aa605>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewNew_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewNew_fragmentRef";
};
export type dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewNew_fragmentRef$key = {
  readonly " $data"?: dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewNew_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewNew_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewNew_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraDateTimePickerField"
};

(node as any).hash = "eeb23ad7c37c54cf808653965b7bf769";

export default node;
